import People from '@material-ui/icons/People';

// import Create from './Create';
// import Edit from './Edit';
import List from './List2';

export default {
  list: List,
  icon: People,
};
